export default __webpack_public_path__ + "static/media/el8.a955785d.svg";